import React from 'react';

export const SvgChevronBack: React.FC<{width?: string, height?: string, fill?: string}> = ({ width = 24, height = 24, fill = 'none' }) => {
  return (
    <svg width={width} height={height} viewBox={`0 0 ${width} ${height}`} fill={fill} xmlns="http://www.w3.org/2000/svg">
      <g clipPath="url(#clip0_1548_373)">
        <path d="M15 6L9 12L15 18" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </g>
      <defs>
        <clipPath id="clip0_1548_373">
          <rect width={width} height={height} fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
